import { dateFormat } from "shared/util"
import { Chip, IconButton, Stack, Tooltip, Typography } from "@mui/material"
import {
	CloseIcon,
  PreviousIcon,
  NextIcon
} from 'shared/icons'

import { useTrialPreview } from "features/trial/preview/container"
import { TrialResult } from "interface/trial"

type TrialPreviewHeaderProps = {
	trial: TrialResult
	container: ReturnType<typeof useTrialPreview>
}
export const TrialPreviewHeader = ({
	trial,
	container: {
		hasPrev, openPrev, hasNext, openNext, onClose
	}
}: TrialPreviewHeaderProps) => {
	return (
		<Stack direction='column' padding={1}>
			<Stack direction='row' spacing={1} justifyContent='flex-start' alignItems='flex-start'>
				<Stack direction='column' flexGrow={1}>
					<Stack direction='row' spacing={1} flexWrap="wrap">
						{trial.trialType && <Chip label={trial.trialType} size='small'/>}
						{trial.phase && <Chip label={`フェーズ: ${trial.phase}`} size='small'/>}
						{trial.statusText && <Chip label={`状況: ${trial.statusText}`} size='small'/>}
						{trial.progress && <Chip label={`進捗: ${trial.progress}`} size='small'/>}
						{trial.clinicalTrialsType ? (
							<Typography variant='body2' component='div'>{trial.clinicalTrialsType}</Typography>
						) : <></>}
					</Stack>

					<Typography padding={1} variant='h5' component='div'>{trial.title}</Typography>
				</Stack>
				
				{(hasPrev || hasNext) ? (
					<Stack direction="row">
						{hasPrev ? (
							<Tooltip title="前へ">
								<IconButton onClick={openPrev}><PreviousIcon /></IconButton>
							</Tooltip>
						) : (
							<IconButton disabled><PreviousIcon /></IconButton>
						)}
						{hasNext ? (
							<Tooltip title="次へ">
								<IconButton onClick={openNext}><NextIcon /></IconButton>
							</Tooltip>
						) : (
							<IconButton disabled><NextIcon /></IconButton>
						)}
					</Stack>
				) : <></>}

				{onClose && (
					<Tooltip title='閉じる'><IconButton onClick={onClose}><CloseIcon/></IconButton></Tooltip>
				)}
			</Stack>

			<Stack direction='row' spacing={2} justifyContent='flex-end' flexWrap='wrap'>
				{trial.registrationDate ? (
					<Stack direction='row' spacing={1} alignItems='center'>
						<Typography variant='caption' color='text.secondary' component='span'>登録</Typography>
						<Typography variant='body2' color='text.primary' component='span'>{
							dateFormat(trial.registrationDate, { nullText: trial.registrationDate })
						}</Typography>
					</Stack>
				) : <></>}
				{trial.notificationDate ? (
					<Stack direction='row' spacing={1} alignItems='center'>
						<Typography variant='caption' color='text.secondary' component='span'>届出</Typography>
						<Typography variant='body2' color='text.primary' component='span'>{
							dateFormat(trial.notificationDate, { nullText: trial.notificationDate })
						}</Typography>
					</Stack>
				) : <></>}
				{trial.firstPublicDate || trial.finalPublicDate ? (
					<Stack direction='row' spacing={1} alignItems='center'>
						<Typography variant='caption' color='text.secondary' component='span'>公表</Typography>
						<Typography variant='body2' color='text.primary' component='span'>{
							dateFormat(trial.firstPublicDate, { nullText: trial.firstPublicDate ?? '' }) + '～' +
							dateFormat(trial.finalPublicDate, { nullText: trial.finalPublicDate ?? '' })
						}</Typography>
					</Stack>
				) : <></>}
				{trial.startDate || trial.endDate ? (
					<Stack direction='row' spacing={1} alignItems='center'>
						<Typography variant='caption' color='text.secondary' component='span'>実施</Typography>
						<Typography variant='body2' color='text.primary' component='span'>{
							dateFormat(trial.startDate, { nullText: trial.startDate ?? '' }) + '～' +
							dateFormat(trial.endDate, { nullText: trial.endDate ?? '' })
						}</Typography>
					</Stack>
				) : <></>}
				{trial.terminalDate ? (
					<Stack direction='row' spacing={1} alignItems='center'>
						<Typography variant='caption' color='text.secondary' component='span'>中止</Typography>
						<Typography variant='body2' color='text.primary' component='span'>{
							dateFormat(trial.terminalDate, { nullText: trial.terminalDate })
						}</Typography>
					</Stack>
				) : <></>}
			</Stack>
		</Stack>
	)
}